'use client'

import { SubItemList } from '@/app/ui/parts/default/sp/itemlist/sub/itemlist'
import { queryType } from '@/lib/api/query'
import { campaignType } from '@/lib/campaign'
import { categoryType } from '@/lib/category'
import { getItems, itemType, itemsResponseType } from '@/lib/item/server'
import { serviceType } from '@/lib/service/server'
import { subcategoryType } from '@/lib/subcategory'
import { tagType } from '@/lib/tag'
import { useEffect, useState } from 'react'

type SearchItemListProps = {
  service: serviceType
  subcategory?: subcategoryType
  category?: categoryType
  campaign?: campaignType
  tag?: tagType
  query: queryType
  slider: boolean
}

export const SearchItemListClientComponent: React.FC<SearchItemListProps> = ({
  service,
  query,
  subcategory,
  category,
  campaign,
  tag,
  slider,
}) => {
  //   const { items } = (await getItems(
  //     service.service_id,
  //     query,
  //   )) as itemsResponseType
  const [items, setItems] = useState<itemType[]>([])
  useEffect(() => {
    const fetchData = async () => {
      const data = (await getItems(
        service.service_id,
        query,
      )) as itemsResponseType
      setItems(data.items)
    }
    fetchData().catch((error) => {
      console.error('Error fetching search items:', error)
    })
  }, [service.service_id, query])
  if (items.length === 0) {
    return null
  }
  return (
    <div>
      <SubItemList items={items} service={service} slider={slider} />
      {subcategory && (
        <div className="item-list-bottom text-center mt-4 mb-4">
          <a href={`/subcategory/${subcategory.subcategory_id}`}>
            <button className="item-list-bottom-button relative py-3 px-8 text-sm rounded-lg bg-[#fafafa] border-[#dddddd] border">
              <span className="prefix-text">{service.prefix}の</span>
              {subcategory.name}一覧へ
              <span
                className="item-list-bottom-arrow absolute text-lg font-light"
                style={{ color: '#555353', top: '4px', right: '7px' }}
              >
                {' › '}
              </span>
            </button>
          </a>
        </div>
      )}
      {category && (
        <div className="item-list-bottom text-center mt-4 mb-4">
          <a href={`/category/${category.category_id}`}>
            <button className="item-list-bottom-button bg-[#fafafa] relative py-3 px-8 text-sm rounded-lg border-[#dddddd] border">
              <span className="prefix-text">{service.prefix}の</span>
              {category.name}一覧へ
              <span
                className="item-list-bottom-arrow absolute text-lg font-light"
                style={{ color: '#555353', top: '4px', right: '7px' }}
              >
                {' › '}
              </span>
            </button>
          </a>
        </div>
      )}
      {campaign && (
        <div className="item-list-bottom text-center mt-4 mb-4">
          <a href={`/campaign/${campaign.campaign_id}`}>
            <button className="item-list-bottom-button bg-[#fafafa] relative py-3 px-8 text-sm rounded-lg border-[#dddddd] border">
              {campaign.name}の一覧へ
              <span
                className="item-list-bottom-arrow absolute text-lg font-light"
                style={{ color: '#555353', top: '4px', right: '7px' }}
              >
                {' › '}
              </span>
            </button>
          </a>
        </div>
      )}
      {tag && (
        <div className="item-list-bottom text-center mt-4 mb-4">
          <a href={`/tag/${tag.tag_id}`}>
            <button className="item-list-bottom-button bg-[#fafafa] relative py-3 px-8 text-sm rounded-lg border-[#dddddd] border">
              {tag.name}の一覧へ
              <span
                className="item-list-bottom-arrow absolute text-lg font-light"
                style={{ color: '#555353', top: '4px', right: '7px' }}
              >
                {' › '}
              </span>
            </button>
          </a>
        </div>
      )}
    </div>
  )
}
